// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var DateHelper = require("./DateHelper");
var Lang_eval$BwaxAdmin = require("../../lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Runtime_common$BwaxAdmin = require("../runtime_common.bs.js");

function format(prim, prim$1) {
  return DateHelper.format(prim, prim$1);
}

function parse(prim, prim$1) {
  return DateHelper.parse(prim, prim$1);
}

function parseISO(prim) {
  return DateHelper.parseISO(prim);
}

function year(prim) {
  return DateHelper.year(prim);
}

function weekYear(prim) {
  return DateHelper.weekYear(prim);
}

function month(prim) {
  return DateHelper.month(prim);
}

function date(prim) {
  return DateHelper.date(prim);
}

function weekNumber(prim) {
  return DateHelper.weekNumber(prim);
}

function weekDay(prim) {
  return DateHelper.weekDay(prim);
}

function ordinalDay(prim) {
  return DateHelper.ordinalDay(prim);
}

function quarter(prim) {
  return DateHelper.quarter(prim);
}

function get(prim, prim$1) {
  return DateHelper.get(prim, prim$1);
}

function set(prim, prim$1, prim$2) {
  return DateHelper.set(prim, prim$1, prim$2);
}

function add(prim, prim$1, prim$2) {
  return DateHelper.add(prim, prim$1, prim$2);
}

function subtract(prim, prim$1, prim$2) {
  return DateHelper.subtract(prim, prim$1, prim$2);
}

function diff(prim, prim$1, prim$2) {
  return DateHelper.diff(prim, prim$1, prim$2);
}

function diffFloat(prim, prim$1, prim$2) {
  return DateHelper.diffFloat(prim, prim$1, prim$2);
}

function ceiling(prim, prim$1) {
  return DateHelper.ceiling(prim, prim$1);
}

function floor(prim, prim$1) {
  return DateHelper.floor(prim, prim$1);
}

function isBefore(prim, prim$1) {
  return DateHelper.isBefore(prim, prim$1);
}

function isAfter(prim, prim$1) {
  return DateHelper.isAfter(prim, prim$1);
}

function isSame(prim, prim$1) {
  return DateHelper.isSame(prim, prim$1);
}

function pack_date_from_float(f) {
  return /* tuple */[
          /* V_tagged_number */Caml_chrome_debugger.variant("V_tagged_number", 9, [
              "Date",
              f
            ]),
          Runtime_common$BwaxAdmin.nt
        ];
}

function pack_date(d) {
  return pack_date_from_float(d.getTime());
}

function invalid_args(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        "Date." + (name + ": Invalid Arguments")
      ];
}

function date_to_int(name, proc) {
  var f = Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || !(match.tag === /* V_tagged_number */9 && match[0] === "Date" && !param[1])) {
              return invalid_args(name);
            } else {
              return Runtime_common$BwaxAdmin.pack_int(Curry._1(proc, new Date(match[1])));
            }
          } else {
            return invalid_args(name);
          }
        }));
  return /* tuple */[
          name,
          f
        ];
}

function date_date_to_bool(name, proc) {
  var f = Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || !(match.tag === /* V_tagged_number */9 && match[0] === "Date")) {
              return invalid_args(name);
            } else {
              var match$1 = param[1];
              if (match$1) {
                var match$2 = match$1[0][0];
                if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_number */9 && match$2[0] === "Date" && !match$1[1])) {
                  return invalid_args(name);
                } else {
                  return Runtime_common$BwaxAdmin.pack_bool(Curry._2(proc, new Date(match[1]), new Date(match$2[1])));
                }
              } else {
                return invalid_args(name);
              }
            }
          } else {
            return invalid_args(name);
          }
        }));
  return /* tuple */[
          name,
          f
        ];
}

function unit_date_to_date(name, proc) {
  var f = Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || !(match.tag === /* V_tagged */6 && !match[1])) {
              return invalid_args(name);
            } else {
              var match$1 = param[1];
              if (match$1) {
                var match$2 = match$1[0][0];
                if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_number */9 && match$2[0] === "Date" && !match$1[1])) {
                  return invalid_args(name);
                } else {
                  var d = Curry._2(proc, match[0], new Date(match$2[1]));
                  return pack_date_from_float(d.getTime());
                }
              } else {
                return invalid_args(name);
              }
            }
          } else {
            return invalid_args(name);
          }
        }));
  return /* tuple */[
          name,
          f
        ];
}

function unit_int_date_to_date(name, proc) {
  var f = Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || !(match.tag === /* V_tagged */6 && !match[1])) {
              return invalid_args(name);
            } else {
              var match$1 = param[1];
              if (match$1) {
                var match$2 = match$1[0][0];
                if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
                  return invalid_args(name);
                } else {
                  var match$3 = match$2[0];
                  if (typeof match$3 === "number" || match$3.tag) {
                    return invalid_args(name);
                  } else {
                    var match$4 = match$1[1];
                    if (match$4) {
                      var match$5 = match$4[0][0];
                      if (typeof match$5 === "number" || !(match$5.tag === /* V_tagged_number */9 && match$5[0] === "Date" && !match$4[1])) {
                        return invalid_args(name);
                      } else {
                        var d = Curry._3(proc, match[0], match$3[0], new Date(match$5[1]));
                        return pack_date_from_float(d.getTime());
                      }
                    } else {
                      return invalid_args(name);
                    }
                  }
                }
              } else {
                return invalid_args(name);
              }
            }
          } else {
            return invalid_args(name);
          }
        }));
  return /* tuple */[
          name,
          f
        ];
}

function func(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_Date_now",
              args
            ]),
          Runtime_common$BwaxAdmin.nt
        ];
}

var externals_vals_000 = /* tuple */[
  "now",
  Runtime_common$BwaxAdmin.pack_func(1, func)
];

var externals_vals_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    /* tuple */[
      "fromFloat",
      Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
              if (param) {
                var match = param[0][0];
                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                  return invalid_args("fromFloat");
                } else {
                  var match$1 = match[0];
                  if (typeof match$1 === "number") {
                    return invalid_args("fromFloat");
                  } else {
                    switch (match$1.tag | 0) {
                      case /* Int */0 :
                          if (param[1]) {
                            return invalid_args("fromFloat");
                          } else {
                            return /* tuple */[
                                    /* V_tagged_number */Caml_chrome_debugger.variant("V_tagged_number", 9, [
                                        "Date",
                                        match$1[0]
                                      ]),
                                    Runtime_common$BwaxAdmin.nt
                                  ];
                          }
                      case /* Float */1 :
                          if (param[1]) {
                            return invalid_args("fromFloat");
                          } else {
                            return /* tuple */[
                                    /* V_tagged_number */Caml_chrome_debugger.variant("V_tagged_number", 9, [
                                        "Date",
                                        match$1[0]
                                      ]),
                                    Runtime_common$BwaxAdmin.nt
                                  ];
                          }
                      default:
                        return invalid_args("fromFloat");
                    }
                  }
                }
              } else {
                return invalid_args("fromFloat");
              }
            }))
    ],
    /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "format",
          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[0][0];
                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                      return invalid_args("format");
                    } else {
                      var match$1 = match[0];
                      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                        return invalid_args("format");
                      } else {
                        var match$2 = param[1];
                        if (match$2) {
                          var match$3 = match$2[0][0];
                          if (typeof match$3 === "number" || !(match$3.tag === /* V_tagged_number */9 && match$3[0] === "Date" && !match$2[1])) {
                            return invalid_args("format");
                          } else {
                            return Runtime_common$BwaxAdmin.pack_string(DateHelper.format(match$1[0], new Date(match$3[1])));
                          }
                        } else {
                          return invalid_args("format");
                        }
                      }
                    }
                  } else {
                    return invalid_args("format");
                  }
                }))
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "toJSONString",
              Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || !(match.tag === /* V_tagged_number */9 && match[0] === "Date" && !param[1])) {
                          return invalid_args("toJSONString");
                        } else {
                          return Runtime_common$BwaxAdmin.pack_string(new Date(match[1]).toJSON());
                        }
                      } else {
                        return invalid_args("toJSONString");
                      }
                    }))
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "parse",
                  Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                          if (param) {
                            var match = param[0][0];
                            if (typeof match === "number" || match.tag !== /* V_literal */5) {
                              return invalid_args("parse");
                            } else {
                              var match$1 = match[0];
                              if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                                return invalid_args("parse");
                              } else {
                                var match$2 = param[1];
                                if (match$2) {
                                  var match$3 = match$2[0][0];
                                  if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                                    return invalid_args("parse");
                                  } else {
                                    var match$4 = match$3[0];
                                    if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
                                      return invalid_args("parse");
                                    } else {
                                      var d = DateHelper.parse(match$1[0], match$4[0]);
                                      return pack_date_from_float(d.getTime());
                                    }
                                  }
                                } else {
                                  return invalid_args("parse");
                                }
                              }
                            }
                          } else {
                            return invalid_args("parse");
                          }
                        }))
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "parseISO",
                      Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                              if (param) {
                                var match = param[0][0];
                                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                  return invalid_args("parse");
                                } else {
                                  var match$1 = match[0];
                                  if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
                                    return invalid_args("parse");
                                  } else {
                                    var d = DateHelper.parseISO(match$1[0]);
                                    return pack_date_from_float(d.getTime());
                                  }
                                }
                              } else {
                                return invalid_args("parse");
                              }
                            }))
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        date_to_int("year", year),
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            date_to_int("weekYear", weekYear),
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                date_to_int("month", month),
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    date_to_int("date", date),
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        date_to_int("weekNumber", weekNumber),
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            date_to_int("weekDay", weekDay),
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                date_to_int("ordinalDay", ordinalDay),
                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                    date_to_int("quarter", quarter),
                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                        /* tuple */[
                                                          "get",
                                                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                  if (param) {
                                                                    var match = param[0][0];
                                                                    if (typeof match === "number" || !(match.tag === /* V_tagged */6 && !match[1])) {
                                                                      return invalid_args("get");
                                                                    } else {
                                                                      var match$1 = param[1];
                                                                      if (match$1) {
                                                                        var match$2 = match$1[0][0];
                                                                        if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_number */9 && match$2[0] === "Date" && !match$1[1])) {
                                                                          return invalid_args("get");
                                                                        } else {
                                                                          return Runtime_common$BwaxAdmin.pack_int(DateHelper.get(match[0], new Date(match$2[1])));
                                                                        }
                                                                      } else {
                                                                        return invalid_args("get");
                                                                      }
                                                                    }
                                                                  } else {
                                                                    return invalid_args("get");
                                                                  }
                                                                }))
                                                        ],
                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                            unit_int_date_to_date("set", set),
                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                unit_int_date_to_date("add", add),
                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                    unit_int_date_to_date("subtract", subtract),
                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        /* tuple */[
                                                                          "diff",
                                                                          Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                                                                  if (param) {
                                                                                    var match = param[0][0];
                                                                                    if (typeof match === "number" || !(match.tag === /* V_tagged */6 && !match[1])) {
                                                                                      return invalid_args("diff");
                                                                                    } else {
                                                                                      var match$1 = param[1];
                                                                                      if (match$1) {
                                                                                        var match$2 = match$1[0][0];
                                                                                        if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_number */9 && match$2[0] === "Date")) {
                                                                                          return invalid_args("diff");
                                                                                        } else {
                                                                                          var match$3 = match$1[1];
                                                                                          if (match$3) {
                                                                                            var match$4 = match$3[0][0];
                                                                                            if (typeof match$4 === "number" || !(match$4.tag === /* V_tagged_number */9 && match$4[0] === "Date" && !match$3[1])) {
                                                                                              return invalid_args("diff");
                                                                                            } else {
                                                                                              return Runtime_common$BwaxAdmin.pack_int(DateHelper.diff(match[0], new Date(match$2[1]), new Date(match$4[1])));
                                                                                            }
                                                                                          } else {
                                                                                            return invalid_args("diff");
                                                                                          }
                                                                                        }
                                                                                      } else {
                                                                                        return invalid_args("diff");
                                                                                      }
                                                                                    }
                                                                                  } else {
                                                                                    return invalid_args("diff");
                                                                                  }
                                                                                }))
                                                                        ],
                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                            /* tuple */[
                                                                              "diffFloat",
                                                                              Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                                                                      if (param) {
                                                                                        var match = param[0][0];
                                                                                        if (typeof match === "number" || !(match.tag === /* V_tagged */6 && !match[1])) {
                                                                                          return invalid_args("diffFloat");
                                                                                        } else {
                                                                                          var match$1 = param[1];
                                                                                          if (match$1) {
                                                                                            var match$2 = match$1[0][0];
                                                                                            if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_number */9 && match$2[0] === "Date")) {
                                                                                              return invalid_args("diffFloat");
                                                                                            } else {
                                                                                              var match$3 = match$1[1];
                                                                                              if (match$3) {
                                                                                                var match$4 = match$3[0][0];
                                                                                                if (typeof match$4 === "number" || !(match$4.tag === /* V_tagged_number */9 && match$4[0] === "Date" && !match$3[1])) {
                                                                                                  return invalid_args("diffFloat");
                                                                                                } else {
                                                                                                  return Runtime_common$BwaxAdmin.pack_float(DateHelper.diffFloat(match[0], new Date(match$2[1]), new Date(match$4[1])));
                                                                                                }
                                                                                              } else {
                                                                                                return invalid_args("diffFloat");
                                                                                              }
                                                                                            }
                                                                                          } else {
                                                                                            return invalid_args("diffFloat");
                                                                                          }
                                                                                        }
                                                                                      } else {
                                                                                        return invalid_args("diffFloat");
                                                                                      }
                                                                                    }))
                                                                            ],
                                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                unit_date_to_date("ceiling", ceiling),
                                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                    unit_date_to_date("floor", floor),
                                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                        date_date_to_bool("isBefore", isBefore),
                                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                            date_date_to_bool("isAfter", isAfter),
                                                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                date_date_to_bool("isSame", isSame),
                                                                                                /* [] */0
                                                                                              ])
                                                                                          ])
                                                                                      ])
                                                                                  ])
                                                                              ])
                                                                          ])
                                                                      ])
                                                                  ])
                                                              ])
                                                          ])
                                                      ])
                                                  ])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ])
  ]);

var externals_vals = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    externals_vals_000,
    externals_vals_001
  ]);

function date_command(_context, param, on_trunk_msgs, _on_branch_msgs) {
  var cmd = param[0];
  if (typeof cmd === "number" || !(cmd.tag === /* V_tagged */6 && cmd[0] === "Cmd_Date_now")) {
    return false;
  } else {
    var match = cmd[1];
    if (match && !match[1]) {
      var v = Date.now();
      var msg = Lang_eval$BwaxAdmin.apply_value(undefined, match[0], /* tuple */[
            /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Float */Caml_chrome_debugger.variant("Float", 1, [v])]),
            Runtime_common$BwaxAdmin.nt
          ], Runtime_common$BwaxAdmin.nt);
      Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                  msg,
                  /* [] */0
                ])]));
      return true;
    } else {
      return false;
    }
  }
}

var command_handlers = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    date_command,
    /* [] */0
  ]);

var externals_000 = "Date";

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var src = "\nmodule Date;\n\n-- the timestamp of now;\nnow: (Float -> msg) -> Cmd msg = external;\n\n-- TODO\n-- today: (Date -> msg) -> Cmd msg = external;\n\n-- Convert a timestamp number to a Date object\nfromFloat: Float -> Date = external;\n\n-- given a pattern like \"yyyy-mm-dd HH:MM\", convert the given Date to a String\n-- See https://github.com/felixge/node-dateformat\n-- 改了使用 day.js 的格式 \"YYYY-MM-DD HH:mm\"\n-- https://dayjs.gitee.io/docs/zh-CN/display/format\nformat: String -> Date -> String = external;\n\n\ntoJSONString: Date -> String = external;\n\n\n-- https://dayjs.gitee.io/docs/zh-CN/parse/string-format\n-- The first string is format and the second one is date string.\nparse: String -> String -> Date = external;\n\n-- The date string is like 2018-04-04T16:00:00.000Z, which is ISO8601 format.\nparseISO: String -> Date = external;\n\n-- Extract --\n-- The calendar year\nyear: Date -> Int = external;\n\n-- The week numbering year.\nweekYear: Date -> Int = external;\n\n\n-- Month as 0 - 11\nmonth: Date -> Int = external;\n\n-- The date of the month (1 - 31)\ndate: Date -> Int = external;\n\n-- The ISO week number of the year (1 - 53)\nweekNumber: Date -> Int = external;\n\n-- The week day 0 - 6\nweekDay: Date -> Int = external;\n\n-- The day of the year (1 - 366)\nordinalDay: Date -> Int = external;\n\n-- The quarter (1 - 4)\nquarter: Date -> Int = external;\n\n\n--- Operations\n\ntype Unit = Year | Quarter | Month | Week | Date | Day | Hour | Minute | Second | Millisecond;\n\n-- Month 从 0 开始算，0 是一月\n-- Date 接受1到31的数字。 如果超出这个范围，它会进位到月份。\n-- Day 接受从0(星期天)到6(星期六)的数字。 如果超出这个范围，它会进位到其他周。\n\n-- Get specific part of the date = external;\nget: Unit -> Date -> Int = external;\n\n-- Set specific part of the date\nset: Unit -> Int -> Date -> Date = external;\n\n\n-- Add some unit of time to the date.\nadd: Unit -> Int -> Date -> Date = external;\n\n-- Subtract some unit of time for the date\nsubtract: Unit -> Int -> Date -> Date = external;\n\n-- Get the difference, as a number of whole units, between two dates.\ndiff: Unit -> Date -> Date -> Int = external;\n\n-- Get the difference, as a accurate float number of units, between two dates.\ndiffFloat: Unit -> Date -> Date -> Float = external;\n\n\n-- Round up a date to the end of the closest interval. \n-- The resulting date will be greater than or equal to the one provided.\nceiling: Unit -> Date -> Date = external;\n\n-- Round down a date to the beginning of the closest interval. \n-- The resulting date will be less than or equal to the one provided.\nfloor: Unit -> Date -> Date = external;\n\n\n-- Queries\n-- Check if the second date is before the first date.\nisBefore: Date -> Date -> Bool = external;\n\n-- Check if the second date is after the first date.\nisAfter: Date -> Date -> Bool = external;\n\n\n-- Check if the second date is the same as the first date.\nisSame: Date -> Date -> Bool = external;\n\n\n";

exports.src = src;
exports.format = format;
exports.parse = parse;
exports.parseISO = parseISO;
exports.year = year;
exports.weekYear = weekYear;
exports.month = month;
exports.date = date;
exports.weekNumber = weekNumber;
exports.weekDay = weekDay;
exports.ordinalDay = ordinalDay;
exports.quarter = quarter;
exports.get = get;
exports.set = set;
exports.add = add;
exports.subtract = subtract;
exports.diff = diff;
exports.diffFloat = diffFloat;
exports.ceiling = ceiling;
exports.floor = floor;
exports.isBefore = isBefore;
exports.isAfter = isAfter;
exports.isSame = isSame;
exports.pack_date_from_float = pack_date_from_float;
exports.pack_date = pack_date;
exports.invalid_args = invalid_args;
exports.date_to_int = date_to_int;
exports.date_date_to_bool = date_date_to_bool;
exports.unit_date_to_date = unit_date_to_date;
exports.unit_int_date_to_date = unit_int_date_to_date;
exports.externals_vals = externals_vals;
exports.date_command = date_command;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* externals_vals Not a pure module */
